import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { Download, Printer, QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const printFlyer = (src, link, name) => {
  const w = window.open("", "_blank", "width=700,height=900");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>Join LoreRight</title><style>
    body{font-family:Georgia,serif;text-align:center;padding:48px;color:#17120C}
    h1{font-size:40px;margin:0 0 8px}p{font-size:18px;margin:0 0 24px}img{width:360px;height:360px}
    small{display:block;margin-top:20px;font-family:monospace;font-size:13px;color:#555;word-break:break-all}</style></head>
    <body><h1>Build your world on LoreRight</h1><p>${esc(name)} invited you. Scan to start with a 14-day Pro trial.</p>
    <img src="${src}" alt="Invite QR code" onload="setTimeout(()=>window.print(),150)"/><small>${esc(link)}</small></body></html>`);
  w.document.close();
};

export const InviteQR = ({ link, name }) => {
  const [open, setOpen] = useState(false);
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (open && !src) QRCode.toDataURL(link, { width: 720, margin: 2, errorCorrectionLevel: "M", color: { dark: "#17120C", light: "#F6F0E4" } }).then(setSrc);
  }, [open, src, link]);
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} className="shrink-0" data-testid="invite-qr-button"><QrCode className="mr-1 h-4 w-4" />QR code</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="invite-qr-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Scan to join LoreRight</DialogTitle>
            <DialogDescription>Friends who scan this get a 14-day Pro trial and count toward your free month.</DialogDescription>
          </DialogHeader>
          <div className="mx-auto w-full max-w-[320px] rounded-md bg-[#F6F0E4] p-3 animate-in zoom-in-95 fade-in duration-300">
            {src ? <img src={src} alt="Invite link QR code" className="aspect-square w-full" data-testid="invite-qr-image" /> : <div className="aspect-square w-full" />}
          </div>
          <div className="flex justify-center gap-2">
            <Button variant="outline" asChild disabled={!src}><a href={src} download="loreright-invite-qr.png" data-testid="invite-qr-download"><Download className="mr-1 h-4 w-4" />Download</a></Button>
            <Button onClick={() => printFlyer(src, link, name)} disabled={!src} data-testid="invite-qr-print"><Printer className="mr-1 h-4 w-4" />Print flyer</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
